import { useEffect } from 'react';
import { usePreviousValue } from '../../../hooks/usePreviousValue';
import { useDirectSpeech } from '../../DirectSpeech';
export const useNotifyClosing = props => {
  const directSpeech = useDirectSpeech();
  const prevIsOpen = usePreviousValue(props.isOpen);
  const isClosing = !props.isOpen && prevIsOpen;
  useEffect(() => {
    if (isClosing && props.message) {
      directSpeech?.notify(props.message);
    }
  }, [directSpeech, isClosing, props.message]);
};
//# sourceMappingURL=useNotifyClosing.js.map